import React, { useState } from 'react';
import Slider from 'react-slick';
import { getFeaturedSliderSettings } from 'core/config/slides';
import ProductCardHome from 'components/artectum/cards/product-card-home';
import { useInitialFetch } from 'core/context/initialFetchContext';
import QuickViewModal from 'components/artectum/modal/QuickViewModal';
import PlaceholderCard from 'components/artectum/cards/PlaceholderCard'; // Ensure PlaceholderCard is correctly imported

const FeaturedItemV1 = () => {
    const { homeProducts: productsData, loading } = useInitialFetch();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleQuickView = (product) => {
        setSelectedProduct(product);
        setShowModal(true);
    };

    const handleModalClose = () => setShowModal(false);

    return (
        <div>
            <div className="ltn__product-slider-area ltn__product-gutter pt-90 pb-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title-area ltn__section-title-2--- text-center mb-3">
                                {/* <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Destacados</h6> */}
                                <h1 className="section-title mb-0">Productos Destacados</h1>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <div className="row d-flex justify-content-center">
                            {[...Array(4)].map((_, index) => (
                                <div className="col-md-3 col-sm-6 col-6" key={index}>
                                    <PlaceholderCard /> {/* Mostrar el placeholder card mientras se cargan los datos */}
                                </div>
                            ))}
                        </div>
                    ) : (
                        productsData?.length === 1 ? (
                            <div className="row d-flex justify-content-center">
                                {productsData?.map((item, index) => (
                                    <div className="col-md-3 col-sm-6 col-6" key={index}>
                                        <ProductCardHome redirect={true} item={item} onQuickView={handleQuickView} loading={loading} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Slider {...getFeaturedSliderSettings(productsData?.length)}>
                                {productsData?.map((item, index) => (
                                    <div key={index}>
                                        <div className="col-md-12 col-10 m-auto p-0 m-md-0" key={index}>
                                            <ProductCardHome redirect={true} item={item} onQuickView={handleQuickView} loading={loading} />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )
                    )}
                </div>
                {selectedProduct && (
                    <QuickViewModal
                        show={showModal}
                        product={selectedProduct}
                        onHide={handleModalClose}
                        item={selectedProduct}
                    />
                )}
            </div>
        </div>
    );
};

export default FeaturedItemV1;